// extracted by mini-css-extract-plugin
export default {"module":"landingVideo_module__WzSrX","content":"landingVideo_content__JBWWg","playButton":"landingVideo_playButton__Q8I+t"};